if (!customElements.get('plusm-pattern-pair')) {
  customElements.define('plusm-pattern-pair', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.sectionId) return;
        const updated = data.html.getElementById(this.id);
        if (!updated) { this.hidden = true; return; }
        this.innerHTML = updated.innerHTML;
        this.hidden = updated.hidden;
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
